module.exports = __webpack_public_path__ + "img/stephen-a-douglass.4aa66cc9.png";